export default __webpack_public_path__ + "static/media/watch-vault-1080.2c461c64.svg";